export const SHOW = {
  electricidad: false,
  climatizacion: false,
  vatiocentral: false,
};
